"use client";

export function isMeiliPerfDebugEnabled(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  return window.localStorage.getItem("meili_perf_debug") === "1";
}

export function logMeiliPerf(
  label: string,
  payload?: Record<string, unknown>,
): void {
  if (!isMeiliPerfDebugEnabled()) {
    return;
  }

  console.info(`[meili-perf] ${label}`, payload ?? {});
}
